function filterByTaxonomy(element) {
    let $select = $(element);
    let $filteredPostsWrapper = $select
        .parent()
        .parent()
        .find('.js-filtered-posts');

    $select.on('change', e => {
        let data = {
            action: 'ajax_filterByTaxonomy',
            term_slug: e.target.value,
            post_type: $select.data('post-type'),
            taxonomy: $select.data('taxonomy')
        };

        $.ajax({
            url: wp_localized_params.ajax_url,
            data,
            type: 'POST',
            beforeSend: function(xhr) {
                $filteredPostsWrapper.html('Loading...');
                $select.attr('disabled', 'disabled');
            },
            success: function(data) {
                $filteredPostsWrapper.html(data.posts);
            },
            error: function(err) {
                console.log(err);
                $filteredPostsWrapper.html('error happend');
            },
            complete: function(data) {
                $select.removeAttr('disabled');
            }
        });
    });
}

export default filterByTaxonomy;
